/*
 * @Author: xing.huang
 * @Date: 2020-09-21 10:44:00
 * @LastEditTime: 2020-09-21 10:44:36
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\util\ElCommonUtils.js
 * @
 */
export default {
	//转换时间戳
	changeToDate: function(row, column, cellValue, index,isShow) {
		return commonUtils.timestampToDate(cellValue,isShow);
	}
}


// WEBPACK FOOTER //
// ./src/util/ElCommonUtils.js